import React from "react";
import HowWeHelp from "../components/HowWeHelp";
import AboutUsHero from "../components/AboutUsHero";
import AboutUsMission from "../components/AboutUsMission";
import AboutUsCoreValues from "../components/AboutUsCoreValue";

const AboutUsPage = () => {
    return (
        <div>
            <AboutUsHero />
            <AboutUsMission />
            <AboutUsCoreValues />
            <HowWeHelp />
        </div>
    );
};

export default AboutUsPage;
